import { render, staticRenderFns } from "./DialogPopup.vue?vue&type=template&id=55003524&scoped=true"
import script from "./DialogPopup.vue?vue&type=script&lang=js"
export * from "./DialogPopup.vue?vue&type=script&lang=js"
import style0 from "./DialogPopup.vue?vue&type=style&index=0&id=55003524&prod&lang=css"
import style1 from "./DialogPopup.vue?vue&type=style&index=1&id=55003524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55003524",
  null
  
)

export default component.exports